import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeadset, faSms, faTimes } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp, faTelegram } from "@fortawesome/free-brands-svg-icons";

const SupportWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  // FIX 1: New state to track if user has clicked the button yet
  const [hasInteracted, setHasInteracted] = useState(false);

  const whatsappNumber = "989356312402";
  const SmsNumber = "+989999613076";
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;
  const telegramUrl = `https://t.me/captainsia003`;
  const smsUrl = `sms:${SmsNumber}`;

  const handleToggle = () => {
    // FIX 2: Set interaction to true on the first click
    if (!hasInteracted) setHasInteracted(true);
    setIsOpen(!isOpen);
  };

  const handleClose = () => setIsOpen(false);

  const handleOptionClick = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
    handleClose();
  };

  return (
    <>
      <style jsx>{`
        .support-widget {
          position: fixed;
          bottom: 80px;
          left: 16px;
          z-index: 1000;
        }

        .support-fab {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: linear-gradient(135deg, #053251 0%, #074a6b 100%);
          border: 2px solid #7cc890;
          color: white;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow:
            0 4px 16px rgba(5, 50, 81, 0.3),
            0 8px 32px rgba(5, 50, 81, 0.15);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
        }

        .support-fab:hover {
          transform: translateY(-4px) scale(1.05);
          box-shadow:
            0 8px 24px rgba(5, 50, 81, 0.4),
            0 12px 40px rgba(5, 50, 81, 0.2);
          border-color: white;
        }

        .support-fab:active {
          transform: translateY(-2px) scale(1.02);
        }

        .support-fab.open {
          background: linear-gradient(135deg, #7cc890 0%, #6ab77d 100%);
          border-color: #053251;
          transform: rotate(180deg);
        }

        .support-fab::before {
          content: "";
          position: absolute;
          top: -2px;
          left: -2px;
          right: -2px;
          bottom: -2px;
          border-radius: 50%;
          background: linear-gradient(45deg, #7cc890, #053251, #7cc890);
          z-index: -1;
          opacity: 0;
          animation: borderGlow 3s ease-in-out infinite;
        }

        @keyframes borderGlow {
          0%,
          100% {
            opacity: 0;
          }
          50% {
            opacity: 0.7;
          }
        }

        .support-fab-icon {
          font-size: 24px;
          transition: all 0.3s ease;
        }

        .support-fab.open .support-fab-icon {
          transform: rotate(180deg);
        }

        .support-popup {
          position: absolute;
          bottom: 70px;
          left: 0;
          background: white;
          border-radius: 16px;
          box-shadow: 0 8px 32px rgba(5, 50, 81, 0.15);
          border: 1px solid rgba(5, 50, 81, 0.1);
          min-width: 260px;
          overflow: hidden;
          transform-origin: bottom left;

          /* FIX 3: Conditional Animation Logic 
             - If Open: Run SlideIn
             - If Closed but interacted: Run SlideOut
             - If Closed and never interacted: No animation (prevents flash)
          */
          animation: ${isOpen
              ? "popupSlideIn"
              : hasInteracted
                ? "popupSlideOut"
                : "none"}
            0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;

          opacity: ${isOpen ? "1" : "0"};
          pointer-events: ${isOpen ? "auto" : "none"};
        }

        @keyframes popupSlideIn {
          from {
            opacity: 0;
            transform: scale(0.8) translateY(20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        @keyframes popupSlideOut {
          from {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
          to {
            opacity: 0;
            transform: scale(0.8) translateY(20px);
          }
        }

        .popup-header {
          background: linear-gradient(135deg, #053251 0%, #074a6b 100%);
          color: white;
          padding: 16px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid rgba(124, 200, 144, 0.2);
        }

        .popup-title {
          font-size: 16px;
          font-weight: 600;
          font-family: "iran-sans", "MyPersianFont", sans-serif;
        }

        .popup-close {
          background: rgba(255, 255, 255, 0.2);
          border: none;
          border-radius: 8px;
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: white;
          transition: all 0.2s ease;
        }

        .popup-close:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: rotate(90deg);
        }

        .popup-notice {
          padding: 10px 20px;
          background: rgba(124, 200, 144, 0.08);
          border-bottom: 1px solid rgba(5, 50, 81, 0.05);
          font-size: 12px;
          line-height: 1.6;
          color: #053251;
          font-family: "iran-sans", "MyPersianFont", sans-serif;
          direction: rtl;
          text-align: right;
        }

        .support-option {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 16px 20px;
          cursor: pointer;
          transition: all 0.2s ease;
          border: none;
          background: none;
          width: 100%;
          text-align: right;
          color: #053251;
          text-decoration: none;
          border-bottom: 1px solid rgba(5, 50, 81, 0.05);
        }

        .support-option:last-child {
          border-bottom: none;
        }

        .support-option:hover {
          background: linear-gradient(
            90deg,
            rgba(124, 200, 144, 0.08) 0%,
            rgba(124, 200, 144, 0.04) 100%
          );
          transform: translateX(-4px);
        }

        .support-option-icon {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
          transition: all 0.2s ease;
        }

        .support-option:hover .support-option-icon {
          transform: scale(1.1);
        }

        .whatsapp-icon {
          color: #25d366;
        }

        .telegram-icon {
          color: #0088cc;
        }

        .sms-icon {
          color: #1e88e5;
        }

        .support-option-text {
          flex: 1;
          font-size: 14px;
          font-weight: 500;
          font-family: "iran-sans", "MyPersianFont", sans-serif;
          direction: rtl;
        }

        .support-backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: transparent;
          z-index: 999;
          opacity: ${isOpen ? "1" : "0"};
          pointer-events: ${isOpen ? "auto" : "none"};
          transition: opacity 0.3s ease;
        }

        /* Pulse animation for attention */
        .support-fab:not(.open)::after {
          content: "";
          position: absolute;
          top: -4px;
          left: -4px;
          right: -4px;
          bottom: -4px;
          border-radius: 50%;
          border: 2px solid #7cc890;
          opacity: 0;
          animation: pulse 2s ease-out infinite;
        }

        @keyframes pulse {
          0% {
            opacity: 1;
            transform: scale(1);
          }
          100% {
            opacity: 0;
            transform: scale(1.4);
          }
        }

        /* Mobile responsive */
        @media (max-width: 768px) {
          .support-widget {
            bottom: 90px;
            left: 12px;
          }

          .support-popup {
            min-width: 240px;
          }

          .popup-header {
            padding: 14px 16px;
          }

          .popup-title {
            font-size: 14px;
          }

          .popup-notice {
            padding: 8px 16px;
            font-size: 11px;
          }

          .support-option {
            padding: 14px 16px;
          }

          .support-option-text {
            font-size: 13px;
          }
        }

        @media (max-width: 480px) {
          .support-widget {
            bottom: 70px;
          }

          .support-fab {
            width: 50px;
            height: 50px;
          }

          .support-fab-icon {
            font-size: 20px;
          }

          .support-popup {
            min-width: 220px;
          }
        }
      `}</style>

      {/* Backdrop */}
      {isOpen && <div className="support-backdrop" onClick={handleClose} />}

      <div className="support-widget">
        {/* Support Options Popup */}
        <div className="support-popup">
          <div className="popup-header">
            <div className="popup-title">راه‌های تماس</div>
            <button className="popup-close" onClick={handleClose}>
              <FontAwesomeIcon icon={faTimes} size="sm" />
            </button>
          </div>

          <div className="popup-notice">
            لطفاً فقط سوالات مربوط به سایت را از این طریق مطرح کنید.
          </div>

          <button
            className="support-option"
            onClick={() => handleOptionClick(whatsappUrl)}
          >
            <FontAwesomeIcon
              icon={faWhatsapp}
              className="support-option-icon whatsapp-icon"
            />
            <span className="support-option-text">ارسال پیام در واتساپ</span>
          </button>

          <button
            className="support-option"
            onClick={() => handleOptionClick(telegramUrl)}
          >
            <FontAwesomeIcon
              icon={faTelegram}
              className="support-option-icon telegram-icon"
            />
            <span className="support-option-text">ارسال پیام در تلگرام</span>
          </button>

          <button
            className="support-option"
            onClick={() => handleOptionClick(smsUrl)}
          >
            <FontAwesomeIcon
              icon={faSms}
              className="support-option-icon sms-icon"
            />
            <span className="support-option-text">ارسال پیامک (sms)</span>
          </button>
        </div>

        {/* Main Support Button */}
        <button
          className={`support-fab ${isOpen ? "open" : ""}`}
          onClick={handleToggle}
          aria-label="پشتیبانی"
        >
          <FontAwesomeIcon
            icon={isOpen ? faTimes : faHeadset}
            className="support-fab-icon"
          />
        </button>
      </div>
    </>
  );
};

export default SupportWidget;
